export default __webpack_public_path__ + "static/68970-8cd31606e22494d049b48c9a9c175237.jpg";